module.exports = "/assets/connect/fonts/BrenntagSans-Bold.woff";